<template>
  <!--  卡券兑换-->
  <div class="couponExchange">
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">积分兑换</span>
        <Reback class="row-one-fr" @click.native="reback"></Reback>
      </el-row>
      <div class="couponExchange-progess" v-show="isSuccess==false">
        <el-form :model="exchangeForm" :rules="exchangeFormRules" ref="exchangeFormRef" label-width="100px" class="form-single margin-t20">
          <el-form-item label="我的积分：">
            <span class="rColor">{{exchangeForm.integralCount}}</span>
          </el-form-item>
          <el-form-item label="兑换商品：" prop="pay">
            <el-radio-group v-model="exchangeForm.pay" style="line-height:22px;" @change="payChange">
              <el-radio style="margin-right:90px;" label="15005566185192142992161389954465">满100减5元</el-radio>
              <el-radio style="margin-right:0;" label="15005566185192142992161389954466">满10000减10.88元</el-radio>
              <el-radio label="15005566185192142992161389954477" style="margin-right:63px;">满10000减20.88元</el-radio>
              <el-radio style="margin-right:91px;" v-show="memberFlag" label="15005565271195634289814020399000">20元立减券</el-radio>
              <el-radio v-show="memberFlag" label="15005565881935425630120197655637">50元立减券</el-radio>
              <el-radio style="margin-right:84px;" v-show=" memberFlag" label="15005566185192142992161389954422">100元立减券</el-radio>
              <el-radio v-show="memberFlag" label="15005566185192142992161389954455">200元立减券</el-radio>
              <el-radio style="margin-right:37px;" label="15005566263192142992161389954433">一年期点财通会员卡</el-radio>
              <!-- <el-radio label="15005566285192142992161389954456">基金诊断卡</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="兑换张数：" prop="num" :error="numError">
            <el-input class="inputThree" v-model="exchangeForm.num" @input="numInput">
              <span slot="suffix" class="form-single-suf">张</span>
            </el-input>
            <el-input style="position:fixed;bottom:-9999px;"></el-input>
          </el-form-item>
          <el-form-item label="使用积分：">
            <span style="color:#ED0000;">{{exchangeForm.remainPoints}}</span>
          </el-form-item>
          <el-form-item label="密码：" prop="pass">
            <el-input class="inputThree" type="password" v-model="exchangeForm.pass" autoComplete="new-password" show-password></el-input>
            <el-input style="position:fixed;bottom:-9999px;"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="margin-t20">
              <el-button type="normal" @click="useNowClick">确认兑换</el-button>
              <el-button type="cancel" @click="reback">返回</el-button>
            </div>
          </el-form-item>
        </el-form>
        <section class="instruction">
          <div class="instruction-li">
            <p class="instruction-li-title">说明</p>
            <p class="instruction-li-con">
              有效期：兑换后30天内有效<br>
              使用规则：1、在购买基金时选用对应金额的基金立减券，可扣除相应的支付金额<br>
              <span class="instruction-li-m5"></span>2、兑换不限数量，可任意兑换<br>
              <span class="instruction-li-m5"></span>3、购买基金时可叠加使用基金立减券<br>
              <span class="instruction-li-m5"></span>4、基金立减券不可转赠他人<br>
              <!-- 积分兑换：<strong class="rColor">2000</strong> -->
            </p>
          </div>
          <div class="instruction-li">
            <p class="instruction-li-title">相关问题</p>
            <p class="instruction-li-con">
              <span class="instruction-li-stress">怎么获得卡券？</span><br>
              方法一：积分兑换 如何获得积分 <span class="sp-s" @click="handleOpen()">如何获得积分</span> 方法二：参加活动获得<br>
              <span class="instruction-li-stress">基金立减券可叠加使用吗</span><br>
              可以<br>
              <span class="instruction-li-stress">如果购买基金确认失败了，购买时所使用的基金立减券会作废吗？</span><br>
              不会的，交易确认失败后卡券会自动返回到您的账户，您可以在“卡券”中查看<br>
              <span class="instruction-li-stress">基金立减券是否可以找零？</span><br>
              卡券使用不设找零，如交易金额小于优惠券金额，卡券剩余金额不予退还。<br>
              <span class="instruction-li-stress">卡券使用时间有限么？</span><br>
              有的，需要具体查看每张卡券的使用期限<br>
            </p>
          </div>
        </section>
      </div>
      <div class="xDetail" v-show="isSuccess==true">
        <div class="xDetail-icon">
          <img src="../../assets/images/hbb/bigRight_230210309.png" width="40" alt="">
        </div>
        <p class="xDetail-title gColor">兑换成功</p>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li v-if="exchangeForm.pay != '15005566263192142992161389954433'" class="xDetail-ul-li"><span>剩余积分：</span><span>{{exchangeForm.integralCount - integral}}</span></li>
          <li v-else class="xDetail-ul-li"><span>会员截至日期：</span><span>{{memberDeadline}}</span></li>
        </ul>
        <hr class="xDetail-hr">
        <div class="xDetail-footer">
          <el-button type="normal" class="fl" @click="$router.push({name:'coupon'})">查看优惠券</el-button>
          <el-button type="normal" class="fr" @click="continueExchange">继续兑换</el-button>
        </div>
      </div>
    </div>
    <getIntegral :isShow="dialogVisible" @handelClose="handleClose()"></getIntegral>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
import getIntegral from "../../components/lv-common/getIntegral";
export default {
  name: "couponExchange",
  components: {
    getIntegral
  },
  data () {
    const isNum = (rule, value, callback) => {
      if (this.exchangeForm.integralCount < this.exchangeForm.remainPoints) {
        callback(new Error('您的积分不够兑换当前张数，请调整'))
      } else {
        callback()
      }
    };
    const ispPass = (rule, value, callback) => {
      var inputpwd = this.$des.enString(this.exchangeForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      var reallypass = this.$commonJs.getCookie('Password')
      if (inputpwd != reallypass) {
        callback(new Error('密码输入错误'))
      } else {
        callback()
      }
    };
    return {
      isSuccess: false,
      dialogVisible: false,
      exchangeForm: {
        integralCount: '--',
        pay: "15005566185192142992161389954465",
        num: '1',
        remainPoints: 500,//使用积分累加
        pass: ''
      },
      exchangeFormRules: {
        pay: [
          { required: true, message: '请选择兑换商品', trigger: 'change' },
        ],
        num: [
          { required: true, message: '请输入兑换张数', trigger: 'blur' },
          { validator: isNum, trigger: 'blur' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: ispPass, trigger: 'blur' },
        ]
      },
      remainPoints: '',
      memberFlag: false,
      integral: 500,//每张使用积分（入参）
      numError: '',
      memberDeadline: '',//会员截至日期
      end: '',
    }
  },
  created () {
    this.memberFlag = window.sessionStorage.getItem('member') == '1' ? true : false
    if (this.$route.params.integral) {
      this.exchangeForm.pay = this.$route.params.integral
      this.integral = this.$commonJs.couponExchange(this.$route.params.integral)
      this.exchangeForm.remainPoints = this.$commonJs.couponExchange(this.$route.params.integral)
    } else {
      this.exchangeForm.pay = this.exchangeForm.pay
    }
  },
  mounted () {
    this.getIntegral()
    this.getMember()
  },
  methods: {
    handleOpen () {
      this.dialogVisible = true;
    },
    handleClose () {
      this.dialogVisible = false;
    },
    reback () {
      const path = this.$route.params.pathName
      path != null ? this.$router.push({ name: path }) : this.$router.push({ name: 'pointsExchange' })

    },
    // 积分兑换
    useNowClick () {
      this.$refs.exchangeFormRef.validate(valid => {
        if (!valid) return
        this.isSuccess = true
        this.$http.post(this.$apiPath.getExchange, {
          custno: this.$commonJs.getCookie('u_custno1'),
          id: this.exchangeForm.pay,//"15005565271195634289814020399000"
          integral: this.integral,//2000
          count: this.exchangeForm.num,//1
        }).then(res => {
          // console.log(res);
          if (res.status !== 200) return
          if (res.data.code == "0000") {
            if (this.exchangeForm.pay == "15005566263192142992161389954433") {
              this.getRenew(this.end)
            } else {
              this.isSuccess = true
            }
          }
        }).catch(err => { })
      })
    },
    // 会员续费
    getRenew (end) {
      var beginyear = Number(end.split("-")[0]);
      var beginmonth = end.split("-")[1];
      var beginday = end.split("-")[2];
      this.memberDeadline = (beginyear + Number(this.exchangeForm.num)) + "-" + beginmonth + "-" + beginday
      // 接口
      this.$http.post(this.$apiPath.buyVipContract, {
        displayname: Base64.decode(this.$commonJs.getCookie('u_name1')),//姓名,
        identify: Base64.decode(this.$commonJs.getCookie('u_id')),//身份证号
        dbegin: end,//开始时间
        dend: this.memberDeadline,// 结束时间
        price: '399',
        sname: '一年会员/',
        createdby: '13776789236870131895588781349156',
        paymode: 'match',
        status: 'checked',
        emtype: 'dct',
        snote: '积分兑换会员卡支付'
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == "200") {
          this.isSuccess = true
        }
      }).catch(err => { })
    },
    // 积分
    getIntegral () {
      this.$http.post(this.$apiPath.getUsIntegral, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.success && res.data.data) {
          this.exchangeForm.integralCount = parseInt(res.data.data.currpoint)
        }
      }).catch(err => { })
    },
    // 会员
    getMember () {
      this.$http.post(this.$apiPath.checkContract, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        // console.log(res);
        if (res.data.data[0]) {
          const memberInfo = res.data.data[0]
          this.end = memberInfo.dend.substr(0, 10)
          if (memberInfo.IsMember == "false") {//非会员
            this.end = this.$commonJs.getDateStrHg(this.$commonJs.getCurrentDate())//今天
          }
        }
      }).catch(err => { })
    },
    payChange (val) {
      this.exchangeForm.remainPoints = this.$commonJs.couponExchange(val) * this.exchangeForm.num.replace(/[^0-9]/ig, '')
      this.integral = this.$commonJs.couponExchange(val)
    },
    numInput (val) {
      var number = /^[0-9]\d*$/;
      if (!number.test(this.exchangeForm.num)) {
        this.exchangeForm.num = this.exchangeForm.num.replace(/[^0-9]/ig, '')
      }
      this.exchangeForm.remainPoints = this.integral * val.replace(/[^0-9]/ig, '')
      // 超过可用积分
      if (this.exchangeForm.integralCount < this.exchangeForm.remainPoints) {
        this.numError = '您的积分不够兑换当前张数，请调整'
      }
    },
    // 继续兑换
    continueExchange () {
      this.$refs.exchangeFormRef.resetFields()
      this.getIntegral()
      this.isSuccess = false
    }

  }
}
</script>

<style scoped lang="less">
.couponExchange {
  .sp-s {
    font-weight: bold;
    color: #246ead;
    margin-left: 8px;
    margin-right: 15px;
    cursor: pointer;
  }
}
</style>
